import { render, staticRenderFns } from "./SiteTextsQuickButtons.vue?vue&type=template&id=e3420d64&"
import script from "./SiteTextsQuickButtons.vue?vue&type=script&lang=js&"
export * from "./SiteTextsQuickButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3420d64')) {
      api.createRecord('e3420d64', component.options)
    } else {
      api.reload('e3420d64', component.options)
    }
    module.hot.accept("./SiteTextsQuickButtons.vue?vue&type=template&id=e3420d64&", function () {
      api.rerender('e3420d64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/sitecontent/SiteTextsQuickButtons.vue"
export default component.exports